import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';

const GET_AI_FILTERS = gql(`
  query GetAIFilters {
    aiFilters {
      ...AIFilterFragment
    }
  }
`);

export const useAIFilters = (skip = false) => {
  const toast = useToast();
  const { data, loading, error } = useQuery(GET_AI_FILTERS, {
    skip,
    onError() {
      toast.error({
        title: 'Failed to fetch AI filters',
        subTitle: 'Please try again',
      });
    },
  });

  return {
    aiFilters: data?.aiFilters || [],
    loading,
    error,
  };
};
